import React from 'react';
import CanWeHelpImg from "../../images/can we help.png";
import LinkedInImg from "../../images/linkidn.svg";
import TwitterImg from "../../images/x.svg";
import FacebookImg from "../../images/fb.svg";
import LeoCussenLogo from "../../images/Leo Cussen Logo-footer.svg";
import CTASection from '../Sections/CTASection';

export const Footer = (props) => {

  return (
    <>
      <CTASection EngineURL={props.EngineURL} />

      <footer className="footer_new" role="contentinfo">

        {/* Floating help button */}
        <div className='can_we_help_button' onClick={() => props.setCanWeHelpStatus(true)}>
          <img src={CanWeHelpImg} alt="Can We Help" className='d-lg-none' />
          <span className='d-none d-lg-block'>Can we help ?</span>
        </div>

        {/* ── Top row: logo + phone + social ── */}
        <div className='footer_new_top'>
          <a href="/" className='footer_new_logo'>
            <img src={LeoCussenLogo} alt="Leo Cussen Centre for Law" />
          </a>
          <div className='footer_new_contact'>
            <a href="tel:1300039031" className='footer_new_phone'>1300 039 031</a>
            <div className='footer_new_social'>
              <a href="https://www.linkedin.com/company/leo-cussen-centre-for-law" target="_blank" rel="noreferrer"><img src={LinkedInImg} alt="LinkedIn" /></a>
              <a href="https://twitter.com/LeoCussen" target="_blank" rel="noreferrer"><img src={TwitterImg} alt="Twitter / X" /></a>
              <a href="https://www.facebook.com/leocussencentreforlaw" target="_blank" rel="noreferrer"><img src={FacebookImg} alt="Facebook" /></a>
            </div>
          </div>
        </div>

        {/* ── Nav columns ── */}
        <div className='footer_new_nav'>
          <div className='footer_new_col'>
            <span className='footer_new_col_heading'>Quick Links</span>
            <nav>
              <a href="https://www.leocussen.edu.au/about-us/" target="_blank" rel="noreferrer">About us</a>
              <a href="https://www.leocussen.edu.au/about-us/our-graduate-alumni/" target="_blank" rel="noreferrer">Our Graduate Alumni</a>
              <a href="https://www.leocussen.edu.au/cpd-for-lawyers-staff/" target="_blank" rel="noreferrer">Continuing Professional Development (CPD) Courses</a>
              <a href="https://store.leocussen.edu.au/corporate_training_division" target="_blank" rel="noreferrer">Corporate Training Division</a>
            </nav>
          </div>
          <div className='footer_new_col'>
            <span className='footer_new_col_heading'>About</span>
            <nav>
              <a href="https://www.leocussen.edu.au/about-us/our-organisation/" target="_blank" rel="noreferrer">Our Organisation</a>
              <a href="https://www.leocussen.edu.au/about-us/careers/" target="_blank" rel="noreferrer">Careers</a>
              <a href="https://www.leocussen.edu.au/about-us/our-graduate-alumni/" target="_blank" rel="noreferrer">Our Graduate Alumni</a>
              <a href="https://www.leocussen.edu.au/about-us/our-organisation/links-and-resources/" target="_blank" rel="noreferrer">Online Legal Resources &amp; Links</a>
            </nav>
          </div>
          <div className='footer_new_col'>
            <span className='footer_new_col_heading'>Law Students &amp; Graduates</span>
            <nav>
              <a href="https://www.leocussen.edu.au/practical-legal-training/" target="_blank" rel="noreferrer">Practical Legal Training</a>
              <a href="https://www.leocussen.edu.au/supervised-legal-trainees/" target="_blank" rel="noreferrer">Trainee Workshops</a>
              <a href="https://www.leocussen.edu.au/practical-legal-training/about-our-plt/overseas-lawyers/" target="_blank" rel="noreferrer">Overseas Lawyers</a>
              <a href="https://www.leocussen.edu.au/practical-legal-training/about-our-plt/requalifying-lawyers/" target="_blank" rel="noreferrer">Requalifying Lawyers</a>
            </nav>
          </div>
          <div className='footer_new_col'>
            <span className='footer_new_col_heading'>CPD Programs – Lawyers and support staff</span>
            <nav>
              <a href="https://www.leocussen.edu.au/cpd-for-lawyers-staff/about-our-cpd/" target="_blank" rel="noreferrer">About our CPD</a>
              <a href="https://store.leocussen.edu.au/" target="_blank" rel="noreferrer">Find CPD Programs</a>
              <a href="https://www.leocussen.edu.au/cpd-for-lawyers-staff/about-our-cpd/terms-and-conditions" target="_blank" rel="noreferrer">Terms &amp; Conditions</a>
            </nav>
          </div>
          <div className='footer_new_col'>
            <nav className='footer_new_col_no_heading'>
              <a href="https://store.leocussen.edu.au/corporate_training_division" target="_blank" rel="noreferrer">Corporate Training Division</a>
              <a href="https://store.leocussen.edu.au/" target="_blank" rel="noreferrer">Find Programs</a>
              <a href="https://www.leocussen.edu.au/contact/" target="_blank" rel="noreferrer">Contact Us</a>
            </nav>
          </div>
        </div>

        {/* ── Bottom bar 1: legal links ── */}
        <div className='footer_new_bar1'>
          <a href="https://www.leocussen.edu.au/copyright/" target="_blank" rel="noreferrer">Copyright</a>
          <a href="https://www.leocussen.edu.au/disclaimer/" target="_blank" rel="noreferrer">Disclaimer</a>
          <a href="https://www.leocussen.edu.au/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
          <a href="https://outlook.office.com/" target="_blank" rel="noreferrer">Staff</a>
          <a href="https://www.leocussen.edu.au/sitemap/" target="_blank" rel="noreferrer">Sitemap</a>
          <a href="https://www.leocussen.edu.au/contact/" target="_blank" rel="noreferrer">Contact</a>
        </div>

        {/* ── Bottom bar 2: copyright + attribution ── */}
        <div className='footer_new_bar2'>
          <div className='footer_new_bar2_left'>
            <p className='footer_new_copyright'>
              © 2026 Leo Cussen Institute trading as Leo Cussen Centre for Law. All Rights Reserved. ABN <strong>16 949 282 178</strong> CRICOS providing number: <strong>02224A</strong>
            </p>
            <p className='footer_new_acknowledgment'>
              Leo Cussen Centre for Law acknowledges the Traditional Custodians of country throughout Australia and their connections to land, sea and community. We pay our respects to their Elders past and present and extend that respect to all Aboriginal and Torres Strait Islander peoples today.
            </p>
          </div>
          <p className='footer_new_attribution'>Designed by Bone, built by <a href="https://saltandfuessel.com.au/" target="_blank" rel="noopener noreferrer">Salt &amp; Fuessel</a></p>
        </div>

      </footer>
    </>
  );
};

export default Footer;
